document.addEventListener('DOMContentLoaded', () => {
  initRevelado();
  initGaleriaProducto();
  initVariantesProducto();
  initBarraFija();
});

function initBarraFija() {
  const barra = document.querySelector('[data-mt-sticky]');
  const principal = document.querySelector('[data-mt-boton-comprar]');
  if (!barra || !principal || !('IntersectionObserver' in window)) return;
  const observador = new IntersectionObserver(
    ([entrada]) => {
      const pasado = !entrada.isIntersecting && entrada.boundingClientRect.top < 0;
      barra.classList.toggle('mt-sticky--visible', pasado);
      barra.setAttribute('aria-hidden', pasado ? 'false' : 'true');
      const boton = barra.querySelector('button');
      if (boton) boton.tabIndex = pasado ? 0 : -1;
    },
    { threshold: 0 }
  );
  observador.observe(principal);
}

function initGaleriaProducto() {
  const galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach((galeria) => {
    const botonesMini = galeria.querySelectorAll('[data-mt-thumb]');
    const imagenes = Array.from(galeria.querySelectorAll('[data-mt-slide]'));
    if (!imagenes.length) return;

    const lightbox = galeria.parentElement.querySelector('[data-mt-lightbox]');
    let indiceActual = 0;

    function activar(indice) {
      indiceActual = ((indice % imagenes.length) + imagenes.length) % imagenes.length;
      botonesMini.forEach((b) => b.classList.remove('mt-activa'));
      imagenes.forEach((img) => img.classList.remove('mt-activa'));
      const boton = galeria.querySelector('[data-mt-thumb="' + indiceActual + '"]');
      if (boton) boton.classList.add('mt-activa');
      imagenes[indiceActual].classList.add('mt-activa');
      if (lightbox && !lightbox.hidden) actualizarLightbox();
    }

    botonesMini.forEach((boton) => {
      boton.addEventListener('click', () => activar(parseInt(boton.getAttribute('data-mt-thumb'), 10)));
    });

    galeria.querySelectorAll('[data-mt-prev]').forEach((b) => b.addEventListener('click', () => activar(indiceActual - 1)));
    galeria.querySelectorAll('[data-mt-next]').forEach((b) => b.addEventListener('click', () => activar(indiceActual + 1)));

    galeria.querySelectorAll('[data-mt-abrir-slide]').forEach((boton) => {
      boton.addEventListener('click', () => abrirLightbox(parseInt(boton.getAttribute('data-mt-abrir-slide'), 10)));
    });

    function actualizarLightbox() {
      const img = lightbox.querySelector('[data-mt-lightbox-img]');
      const fuente = imagenes[indiceActual];
      img.src = fuente.getAttribute('data-full') || fuente.src;
      img.alt = fuente.alt || '';
    }

    function abrirLightbox(indice) {
      if (!lightbox) return;
      activar(indice);
      actualizarLightbox();
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function cerrarLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    if (lightbox) {
      lightbox.querySelectorAll('[data-mt-lightbox-cerrar]').forEach((b) => b.addEventListener('click', cerrarLightbox));
      lightbox.querySelectorAll('[data-mt-lightbox-prev]').forEach((b) => b.addEventListener('click', () => activar(indiceActual - 1)));
      lightbox.querySelectorAll('[data-mt-lightbox-next]').forEach((b) => b.addEventListener('click', () => activar(indiceActual + 1)));
      lightbox.addEventListener('click', (evento) => {
        if (evento.target === lightbox) cerrarLightbox();
      });
      document.addEventListener('keydown', (evento) => {
        if (lightbox.hidden) return;
        if (evento.key === 'Escape') cerrarLightbox();
        if (evento.key === 'ArrowLeft') activar(indiceActual - 1);
        if (evento.key === 'ArrowRight') activar(indiceActual + 1);
      });
    }
  });
}

function initVariantesProducto() {
  const formularios = document.querySelectorAll('[data-mt-form]');
  formularios.forEach((form) => {
    const scriptVariantes = form.querySelector('[data-mt-variantes]');
    if (!scriptVariantes) return;

    let variantes;
    try {
      variantes = JSON.parse(scriptVariantes.textContent);
    } catch (e) {
      return;
    }

    const gruposOpcion = form.querySelectorAll('[data-mt-option-index]');
    const inputId = form.querySelector('[data-mt-variant-id]');
    const boton = form.querySelector('[data-mt-boton-comprar]');
    const botonTexto = form.querySelector('[data-mt-boton-texto]');
    const precioFila = form.closest('.mt-producto-compra')?.querySelector('[data-mt-precio]');

    function seleccionActual() {
      return Array.from(gruposOpcion).map((grupo) => {
        const activo = grupo.querySelector('.mt-variante-pill.mt-activa');
        return activo ? activo.getAttribute('data-mt-option-value') : null;
      });
    }

    function encontrarVariante(seleccion) {
      return variantes.find((v) => {
        const opciones = [v.option1, v.option2, v.option3].filter((o) => o !== null && o !== undefined);
        return opciones.every((valor, i) => valor === seleccion[i]);
      });
    }

    function actualizar() {
      const seleccion = seleccionActual();
      const variante = encontrarVariante(seleccion);
      if (!variante) return;

      inputId.value = variante.id;

      if (precioFila) {
        const actual = precioFila.querySelector('.mt-producto-precio-actual');
        const anterior = precioFila.querySelector('.mt-producto-precio-anterior');
        if (actual) actual.textContent = formatearDinero(variante.price);
        if (anterior) {
          if (variante.compare_at_price && Number(variante.compare_at_price) > Number(variante.price)) {
            anterior.textContent = formatearDinero(variante.compare_at_price);
            anterior.style.display = '';
          } else {
            anterior.style.display = 'none';
          }
        }
      }

      if (boton) {
        boton.disabled = !variante.available;
        if (botonTexto) {
          botonTexto.textContent = variante.available
            ? boton.getAttribute('data-mt-texto-disponible') || botonTexto.textContent
            : boton.getAttribute('data-mt-texto-agotado') || botonTexto.textContent;
        }
      }
    }

    gruposOpcion.forEach((grupo) => {
      const pills = grupo.querySelectorAll('.mt-variante-pill');
      pills.forEach((pill) => {
        pill.addEventListener('click', () => {
          pills.forEach((p) => p.classList.remove('mt-activa'));
          pill.classList.add('mt-activa');
          actualizar();
        });
      });
    });
  });
}

function formatearDinero(centavos) {
  return new Intl.NumberFormat(document.documentElement.lang || 'es', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'USD',
  }).format(Number(centavos) / 100);
}

function initRevelado() {
  const elementos = document.querySelectorAll('.mt-reveal');
  if (!elementos.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elementos.forEach((el) => el.classList.add('mt-visible'));
    return;
  }

  const observador = new IntersectionObserver(
    (entradas) => {
      entradas.forEach((entrada) => {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('mt-visible');
          observador.unobserve(entrada.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  elementos.forEach((el, i) => {
    if (!el.style.getPropertyValue('--mt-delay')) {
      el.style.setProperty('--mt-delay', (i % 6) * 90 + 'ms');
    }
    observador.observe(el);
  });
}
